// ChatDefaultRenderer.jsx
import React from 'react';
import PropTypes from 'prop-types';

import UniversalComponent from '../component/UniversalComponent.jsx';

export const ChatDefaultRenderer = ({
  isOnDesktop = false,
  hasChatroom = false,
  isAuthed = false,
}) => {
  if (isOnDesktop) {
    if (hasChatroom && isAuthed) {
      return (
        <UniversalComponent
          filename="Container_DesktopChatDefault"
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/DesktopChatDefault.js')
          }
        />
      );
    } else {
      return (
        <UniversalComponent
          filename="Container_GridDiscoverUsers"
          withChatLink
          size={104}
          marginTop={12}
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/GridDiscoverUsers.js')
          }
        />
      );
    }
  } else {
    return (
      <UniversalComponent
        filename="Container_Chatrooms"
        importer={/* #__LOADABLE__ */ () => import('../container/Chatrooms.js')}
      />
    );
  }
};

ChatDefaultRenderer.propTypes = {
  hasChatroom: PropTypes.bool,
  isOnDesktop: PropTypes.bool,
  isAuthed: PropTypes.bool,
};

export default ChatDefaultRenderer;
